import React from 'react';
import heroMobileFrameShape from '../../assets/hero-mobile-shape.svg';
import heroMobileWebp from '../../assets/hero-mobile.webp';
import heroMobileJpg from '../../assets/hero-mobile.jpg';
import heroTabletWebp from '../../assets/hero-tablet.webp';
import heroTabletJpg from '../../assets/hero-tablet.jpg';
import heroDesktopWebp from '../../assets/hero-desktop.webp';
import heroDesktopJpg from '../../assets/hero-desktop.jpg';
const AuthImageMobile = ({ alt = '', className = '' }) => {
  const containerStyles = {
    aspectRatio: '439.988 / 120.376',
    WebkitMaskImage: `url(${heroMobileFrameShape})`,
    maskImage: `url(${heroMobileFrameShape})`,
    WebkitMaskSize: '100% 100%',
    maskSize: '100% 100%',
    WebkitMaskRepeat: 'no-repeat',
    maskRepeat: 'no-repeat',
  };

  return (
    <div
      className={`gst-relative gst-w-full gst-overflow-hidden ${className}`}
      style={containerStyles}
    >
      <picture className="gst-absolute gst-inset-0 gst-w-full gst-h-full">
        <source type="image/webp" media="(max-width: 768px)" srcSet={heroMobileWebp} />
        <source type="image/webp" media="(max-width: 1024px)" srcSet={heroTabletWebp} />
        <source type="image/webp" srcSet={heroDesktopWebp} />

        <source type="image/jpeg" media="(max-width: 768px)" srcSet={heroMobileJpg} />
        <source type="image/jpeg" media="(max-width: 1024px)" srcSet={heroTabletJpg} />
        <source type="image/jpeg" srcSet={heroDesktopJpg} />

        <img
          src={heroMobileJpg}
          alt={alt}
          className="gst-absolute gst-inset-0 gst-w-full gst-h-full gst-object-cover"
        />
      </picture>
    </div>
  );
};

export default AuthImageMobile;
